<template>
  <div id="top" @click="closeSelect">
    <headNav :gray="gray"></headNav>
    <!--container-->
    <div class="innerWrapper">
      <h1>Reservation form</h1>
      <div class="container">
        <div class="info">
          <div class="top">${{ item.price }}</div>
          <h2>{{ item.proertyType }}</h2>
          <h3>
            <i v-if="item.apt" style="font-style:normal">{{ item.apt }} / </i
            >{{ item.address }} {{ item.suburb }}
          </h3>
          <h6>{{ item.state }} {{ item.postcode }}</h6>
          <div class="dtl" v-bind:class="'tenant-' + tenant">
            <p>
              <span>Estimated commencement</span
              ><span>{{ item.estimatedCommenceMent }}</span>
            </p>
            <p>
              <span>Estimated completion</span
              ><span>{{ item.estimatedCompletion }}</span>
            </p>
            <p>
              <span>Estimated rental<br />(per week)</span>
              <span style="margin-top:.05rem">
                ${{ item.rental }}
                <i
                  v-if="
                    item.maxRental &&
                      item.maxRental !== '' &&
                      item.maxRental !== 0 &&
                      item.maxRental !== '0'
                  "
                  style="font-style:normal;display:block;line-height:.2rem;float:none;text-align:left"
                >
                  -
                </i>
                <i
                  v-if="
                    item.maxRental &&
                      item.maxRental !== '' &&
                      item.maxRental !== 0 &&
                      item.maxRental !== '0'
                  "
                  style="font-style:normal;display:block;float:none;text-align:left"
                  >${{ item.maxRental }}</i
                >
              </span>
            </p>
            <p v-if="item.proertyType === 'House & Land'">
              <span>Land price</span><span>${{ item.landPrice }}</span>
            </p>
            <p v-if="item.proertyType === 'House & Land'">
              <span>Build price</span><span>${{ item.buildPrice }}</span>
            </p>
            <p>
              <span>Rental yield</span><span>{{ item.rentalYield }}%</span>
            </p>
            <p><span>Incentives</span><span v-html="item.incentives"></span></p>
          </div>
        </div>
        <div class="dtls">
          <h1 v-bind:class="'tenant-' + tenant">Purchaser details</h1>
          <div v-for="(purchaser, index) in allPurchaser" :key="index">
            <h2>Purchaser #{{ purchaser.purchaserId }}</h2>
            <div class="selectItem">
              <div class="title">Title</div>
              <div
                :class="{ open: purchaser.open, red: purchaser.titleWarn }"
                class="select"
              >
                <!--<el-select @change="validateSelect" v-model="purchaser.title" placeholder="select" @visible-change="visible($event, purchaser.purchaserId)">
                    <el-option
                    v-for="item in options"
                    :key="item.key"
                    :label="item.value"
                    :value="item.value">
                    </el-option>
                </el-select>-->
                <div
                  class="mol"
                  @click.stop="openSelect(purchaser.purchaserId, 'title')"
                >
                  {{ purchaser.title }}
                </div>
                <transition name="fade">
                  <ul v-if="purchaser.open" style="height:3.6rem">
                    <li
                      v-for="item in options"
                      :key="item.key"
                      :class="{ selected: item.value == purchaser.title }"
                      @click.stop="posChange(purchaser.purchaserId, item.value)"
                    >
                      {{ item.value }}
                    </li>
                  </ul>
                </transition>
              </div>
            </div>
            <div class="inputItem">
              <div id="first" class="title">First name</div>
              <input
                v-model="purchaser.firstName"
                :class="{ red: signFirName || purchaser.fristWarn }"
                maxlength="25"
                type="text"
                @change="name"
                @input="validateWarn"
                @blur.capture="isFilled"
              />
            </div>
            <div class="inputItem">
              <div id="sur" class="title">Surname</div>
              <input
                v-model="purchaser.surName"
                :class="{ red: signSurName || purchaser.surWarn }"
                maxlength="25"
                type="text"
                @change="name"
                @input="validateWarn"
                @blur.capture="isFilled"
              />
            </div>
            <div class="inputItem">
              <div class="title">Address</div>
              <input
                v-model="purchaser.address"
                :class="{ red: purchaser.addressWarn }"
                maxlength="100"
                type="text"
                @input="validateWarn"
                @blur.capture="isFilled"
              />
            </div>
            <div class="inputItem">
              <div class="title">Suburb</div>
              <input
                v-model="purchaser.suburb"
                :class="{ red: purchaser.suburbWarn }"
                maxlength="50"
                type="text"
                @input="validateWarn"
                @blur.capture="isFilled"
              />
            </div>
            <div class="selectItem">
              <div class="title">State</div>
              <div
                :class="{ open: purchaser.open2, red: purchaser.stateWarn }"
                class="select"
              >
                <!--<el-select @change="validateSelect" v-model="purchaser.state" placeholder="select" @visible-change="visibleState($event, purchaser.purchaserId)">
                    <el-option
                    v-for="item in optionsState"
                    :key="item.key"
                    :label="item.value"
                    :value="item.value">
                    </el-option>
                </el-select>-->
                <div
                  class="mol"
                  @click.stop="openSelect(purchaser.purchaserId, 'state')"
                >
                  {{ purchaser.state }}
                </div>
                <transition name="fade">
                  <ul v-if="purchaser.open2" style="height:6.3rem">
                    <li
                      v-for="item in optionsState"
                      :key="item.key"
                      :class="{ selected: item.value == purchaser.state }"
                      @click.stop="
                        posChange2(purchaser.purchaserId, item.value)
                      "
                    >
                      {{ item.value }}
                    </li>
                  </ul>
                </transition>
              </div>
            </div>
            <div class="inputItem">
              <div class="title">Postcode</div>
              <input
                v-model="purchaser.postcode"
                :class="{ red: purchaser.postcodeWarn }"
                type="number"
                @input="validateWarn($event, 'code', purchaser.purchaserId)"
                @blur.capture="isFilled"
              />
            </div>
            <div class="inputItem">
              <div class="title">Mobile</div>
              <input
                v-model="purchaser.mobile"
                :class="{ red: purchaser.mobileWarn }"
                type="number"
                @input="validateWarn($event, 'mobile', purchaser.purchaserId)"
                @blur.capture="isFilled"
              />
            </div>
            <div class="inputItem">
              <div id="emil" class="title">Email</div>
              <input
                v-model="purchaser.email"
                :class="{ red: purchaser.emailwarn }"
                type="text"
                @change="validateEmail($event, purchaser.purchaserId)"
                @input="validateWarn"
                @blur.capture="isFilled"
              />
              <i
                v-if="purchaser.emailwarn"
                class="close"
                @click="clean('email', purchaser.purchaserId)"
              ></i>
              <strong v-if="purchaser.emailwarn"
                >Email format is incorrect. Please try again.</strong
              >
            </div>
          </div>
          <h4 v-if="allPurchaser.length < 10" @click="add">
            Add another purchaser's details
          </h4>
          <div class="inputItem" style="margin-bottom:16px">
            <div class="title">Purchasing entity</div>
            <input
              v-model="purchasingEntity"
              maxlength="1024"
              type="text"
              @input="validateWarn"
              @blur.capture="isFilled"
            />
          </div>
          <h5>Only if purchasing outside of personal name</h5>
          <h1 style="margin-bottom:.92rem" v-bind:class="'tenant-' + tenant">
            Purchaser's conveyancer/solicitor
          </h1>
          <!-- 8848 增加的复选框 -->
          <div class="newCheck clear">
            <el-checkbox v-model="checked" class="checkleft"></el-checkbox>
            <div class="p">
              <b
                >Please check the box if you currently do not have a
                conveyancer/solicitor. An approved UNIFI conveyancer/solicitor
                will be provided for you.</b
              >
            </div>
          </div>
          <div class="inputItem">
            <div class="title">Company name</div>
            <input
              v-model="legal.companyName"
              :class="{ red: legal.companyWarn }"
              maxlength="50"
              type="text"
              @input="legalhandleInput"
              @blur.capture="isFilled"
            />
          </div>
          <div class="inputItem">
            <div class="title">Contact person</div>
            <input
              v-model="legal.person"
              :class="{ red: legal.personWarn }"
              maxlength="50"
              type="text"
              @input="legalhandleInput"
              @blur.capture="isFilled"
            />
          </div>
          <div class="inputItem">
            <div class="title">Address</div>
            <input
              v-model="legal.address"
              :class="{ red: legal.addressWarn }"
              maxlength="100"
              type="text"
              @input="legalhandleInput"
              @blur.capture="isFilled"
            />
          </div>
          <div class="inputItem">
            <div class="title">Suburb</div>
            <input
              v-model="legal.suburb"
              :class="{ red: legal.suburbWarn }"
              maxlength="50"
              type="text"
              @input="legalhandleInput"
              @blur.capture="isFilled"
            />
          </div>
          <div class="selectItem">
            <div class="title">State</div>
            <div
              :class="{ open: legal.openState, red: legal.stateWarn }"
              class="select"
            >
              <!--<el-select @change="validateSelect" v-model="legal.state" placeholder="select" @visible-change="legalVisibleState">
                  <el-option
                  v-for="item in optionsState"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  </el-option>
              </el-select>-->
              <div class="mol" @click.stop="openlegel">{{ legal.state }}</div>
              <transition name="fade">
                <ul v-if="legal.openState" style="height:6.3rem">
                  <li
                    v-for="item in optionsState"
                    :key="item.key"
                    :class="{ selected: item.value == legal.state }"
                    @click.stop="posChange3(item.value)"
                  >
                    {{ item.value }}
                  </li>
                </ul>
              </transition>
            </div>
          </div>
          <div class="inputItem">
            <div class="title">Postcode</div>
            <input
              v-model="legal.postcode"
              :class="{ red: legal.postcodeWarn }"
              type="number"
              @input="legalhandleInput($event, 'code')"
              @blur.capture="isFilled"
            />
          </div>
          <div class="inputItem">
            <div class="title">Phone</div>
            <input
              v-model="legal.phone"
              :class="{ red: legal.phoneWarn }"
              type="number"
              @input="legalhandleInput($event, 'phone')"
              @blur.capture="isFilled"
            />
          </div>
          <div class="inputItem">
            <div class="title">Mobile</div>
            <input
              v-model="legal.mobile"
              :class="{ red: legal.mobileWarn }"
              type="number"
              @input="legalhandleInput($event, 'mobile')"
              @blur.capture="isFilled"
            />
          </div>
          <div class="inputItem">
            <div class="title">Email</div>
            <input
              v-model="legal.email"
              :class="{ red: legal.emailWarn }"
              type="text"
              @change="legalValidateEmail"
              @input="legalhandleInput"
              @blur.capture="isFilled"
            />
            <i v-if="legal.emailWarn" class="close" @click="legalClean"></i>
            <strong v-if="legal.emailWarn"
              >Email format is incorrect. Please try again.</strong
            >
          </div>
          <h1 v-bind:class="'tenant-' + tenant">
            Executed as an agreement (By Client or Referrer on behalf of client)
          </h1>
          <div class="inputItem">
            <div class="title">Name</div>
            <input
              v-model="agreementName"
              :class="{ red: agreementNameWarn }"
              maxlength="50"
              type="text"
              @input="validateWarn"
              @blur.capture="isFilled"
            />
          </div>
          <div class="inputItem">
            <div class="title">Date</div>
            <div :class="{ red: agreementDateWarn }" class="date reserve">
              <el-date-picker
                v-model="agreementDate"
                :editable="false"
                format="dd/MM/yyyy"
                placeholder="select"
                type="date"
                value-format=""
                @change="dateChange"
              >
              </el-date-picker>
            </div>
          </div>
          <button :class="{ active: haveSign }" @click="toSign">
            Sign reservation form
          </button>
          <h1 v-bind:class="'tenant-' + tenant">Introducer's details</h1>
          <p class="clear">
            Company name:<i>{{ user.companyName }}</i>
          </p>
          <p class="clear">
            Contact person:<i>{{ user.firstName }} {{ user.lastName }}</i>
          </p>
          <p class="clear">
            Address:<i
              >{{ user.address }}, {{ user.suburb }}, {{ user.state }},
              {{ user.postcode }}</i
            >
          </p>
          <p class="clear">
            Phone number:<i>{{ user.phoneNumber }}</i>
          </p>
          <p class="clear">
            Mobile:<i>{{ user.mobileNumber }}</i>
          </p>
          <p class="clear">
            Email<i>{{ user.email }}</i>
          </p>
          <button @click="edit">Edit my details</button>
        </div>
        <div class="payWrp">
          <h1>Payment</h1>
          <div class="inputItem">
            <div class="title">Card name</div>
            <input
              v-model="cardInfo.cardName"
              :class="{ red: cardInfo.cardNameWarn }"
              maxlength="40"
              type="text"
              @input="cardHandleInput($event, 'name')"
              @blur.capture="isFilled"
            />
          </div>
          <div class="out">
            <div class="bigInputItem">
              <div class="title">Card number</div>
              <input
                v-model="cardInfo.cardNumber"
                :class="{ red: cardInfo.cardNumberWarn }"
                maxlength="16"
                type="number"
                @input="cardHandleInput($event, 'number')"
                @blur.capture="isFilled('validate')"
              />
              <i
                :class="{
                  visa: cardType == 'visa',
                  master: cardType == 'master'
                }"
              ></i>
            </div>
            <div class="tripleInputItem clear">
              <div class="smlInputItem">
                <div class="inn">
                  <div class="title">Expiry</div>
                  <div :class="{ red: cardInfo.cardDate }" class="input clear">
                    <input
                      ref="month"
                      v-model="cardInfo.cardMonth"
                      maxlength="2"
                      type="number"
                      @input="cardHandleInput($event, 'month')"
                      @blur.capture="isFilled"
                    />
                    <span>/</span>
                    <input
                      ref="year"
                      v-model="cardInfo.cardYear"
                      maxlength="2"
                      type="number"
                      @input="cardHandleInput($event, 'year')"
                      @blur.capture="isFilled"
                    />
                  </div>
                </div>
              </div>
              <div class="smlInputItem">
                <div class="inn">
                  <div class="title">CVV</div>
                  <input
                    v-model="cardInfo.cardCvv"
                    :class="{ red: cardInfo.cardCvvWarn }"
                    maxlength="3"
                    type="number"
                    @input="cardHandleInput($event, 'cvv')"
                    @blur.capture="isFilled"
                  />
                </div>
              </div>
            </div>
          </div>
          <p class="p1">
            Please note the $1000 reservation fee is completely refundable
            should you not go ahead to contract. An additional transaction fee
            of 3% + 30c for domestic and international cards is a non-refundable
            fee.
          </p>
          <p class="p2">
            Secure payment transactions powered by Stripe and secured with
            256-bit encryption.
          </p>
        </div>
        <div class="more">
          <h2>
            Congratulations on your property reservation. You will receive a
            call from an UNIFI representative within the next 24 hours.
          </h2>
          <button @click="submit">Pay & submit reservation</button>
          <p>
            Once UNIFI has accepted this reservation the purchaser is entitled
            to a 7 day exclusive period, free of competition, to seek advice and
            proceed with the sale.
          </p>
        </div>
      </div>
      <!--pop-->
      <transition name="fade">
        <div v-if="showsign" class="popWrp">
          <div class="out">
            <div class="inn">
              <h2>
                Please read the reservation form in detail and sign at the
                corresponding location.
              </h2>
              <a :href="link" class="close" target="_self" @click="closesign"
                >Okay</a
              >
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!--footer-->
    <foot-nav></foot-nav>
  </div>
</template>

<script>
import headNav from "@/components/package/nav";
import footNav from "@/components/package/footer";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      haveSign: false,
      showsign: false,
      link: "",
      ipad: false,
      checked: false, // 是否选中，选中则非必填。
      cardType: "",
      item: {},
      user: {},
      url:
        "https://account.docusign.com/oauth/auth?\
response_type=code\
&scope=signature\
&client_id=53616529-a161-4983-9876-39627b6d76f2\
&redirect_uri=http://unifiproperty.com/",
      signwarn: false,
      gray: true,
      num: 1,
      disable: true,
      options: [
        {
          value: "Mr.",
          key: 0
        },
        {
          value: "Ms.",
          key: 1
        },
        {
          value: "Dr.",
          key: 2
        },
        {
          value: "Miss.",
          key: 3
        },
        {
          value: "Mrs.",
          key: 4
        }
      ],
      optionsState: [
        {
          value: "New South Wales",
          key: 0
        },
        {
          value: "Queensland",
          key: 1
        },
        {
          value: "South Australia",
          key: 2
        },
        {
          value: "Tasmania",
          key: 3
        },
        {
          value: "Victoria",
          key: 4
        },
        {
          value: "Western Australia",
          key: 5
        },
        {
          value: "Northern Territory",
          key: 6
        },
        {
          value: "ACT",
          key: 7
        },
        {
          value: "ALL",
          key: 8
        }
      ],
      // 签名用的名字是否填写
      signSurName: false,
      signFirName: false,
      allPurchaser: [
        {
          purchaserId: 1,
          title: "",
          titleWarn: false,
          open: false,
          open2: false,
          state: "",
          stateWarn: false,
          openState: false,
          firstName: "",
          fristWarn: false,
          surName: "",
          surWarn: false,
          address: "",
          addressWarn: false,
          suburb: "",
          suburbWarn: false,
          mobile: "",
          mobileWarn: false,
          email: "",
          postcode: "",
          postcodeWarn: false,
          emailwarn: false
        }
      ],
      /* 法人start */
      legal: {
        companyName: "",
        companyWarn: false,
        person: "",
        personWarn: false,
        address: "",
        addressWarn: false,
        suburb: "",
        suburbWarn: false,
        state: "",
        stateWarn: false,
        postcode: "",
        postcodeWarn: false,
        openState: false,
        email: "",
        emailWarn: false,
        mobile: "",
        mobileWarn: false,
        phone: "",
        phoneWarn: false
      },
      /* 法人end */
      cardInfo: {
        cardName: "",
        cardNameWarn: false,
        cardNumber: "",
        cardNumberWarn: false,
        cardCvv: "",
        cardCvvWarn: false,
        cardMonth: "",
        cardYear: "",
        cardDate: false
      },
      // 其他信息
      agreementDate: "",
      agreementDateWarn: false,
      agreementName: "",
      agreementNameWarn: false,
      purchasingEntity: "",
      // 用来判断是否输入完整的promise
      promisePurchaser: null,
      promiseLegal: null,
      promiseOther: null,
      tenant: window.location.hostname
        .replace("m.", "")
        .split(".")[0]
        .split("testunifiproperty")[0]
        .split("unifiproperty")[0]
        .split("platform")[0]
    };
  },
  created() {
    var that = this;
    if (!that.$route.params.id) {
      that.$router.push("/");
      return;
    }
    that.getPropertyDtl({
      params: { id: that.$route.params.id, roomId: that.$route.params.roomId },
      callback: that.callback
    });
    that.getUserDtl({ callback: that.userCallback });
    // 从签名过来的
    if (that.$route.query.from == "0") {
      this.$nextTick(() => {
        that.cardType = localStorage.getItem("cardType");
        that.signwarn = localStorage.getItem("signwarn");
        that.num = JSON.parse(localStorage.getItem("num"));
        that.disable = localStorage.getItem("disable");
        that.signSurName = JSON.parse(localStorage.getItem("signSurName"));
        that.signFirName = JSON.parse(localStorage.getItem("signFirName"));
        that.allPurchaser = JSON.parse(localStorage.getItem("allPurchaser"));
        that.legal = JSON.parse(localStorage.getItem("legal"));
        that.cardInfo = JSON.parse(localStorage.getItem("cardInfo"));
        that.agreementDate = localStorage.getItem("agreementDate");
        that.agreementDateWarn = JSON.parse(
          localStorage.getItem("agreementDateWarn")
        );
        that.agreementName = localStorage.getItem("agreementName");
        that.agreementNameWarn = JSON.parse(
          localStorage.getItem("agreementNameWarn")
        );
        that.purchasingEntity = localStorage.getItem("purchasingEntity");
        that.promisePurchaser = localStorage.getItem("promisePurchaser");
        that.promiseLegal = localStorage.getItem("promiseLegal");
        that.promiseOther = localStorage.getItem("promiseOther");
        that.checked = JSON.parse(localStorage.getItem("checked"));
      });
    }
  },
  mounted() {
    document.getElementById("top").scrollIntoView();
    if (/iPad/i.test(navigator.userAgent)) {
      this.ipad = true;
    }
  },
  activated() {
    var that = this;
    if (this.$route.query.from !== 0 && that.time == 0) {
      that.haveSign = false;
      document.getElementById("top").scrollIntoView();
      that.addtime();
      that.checked = false;
      that.cardType = "";
      that.item = {};
      that.user = {};
      that.signwarn = false;
      that.gray = true;
      that.num = 1;
      that.disable = true;
      that.signSurName = false;
      that.signFirName = false;
      that.allPurchaser = [
        {
          purchaserId: 1,
          title: "",
          titleWarn: false,
          open: false,
          open2: false,
          state: "",
          stateWarn: false,
          openState: false,
          firstName: "",
          fristWarn: false,
          surName: "",
          surWarn: false,
          address: "",
          addressWarn: false,
          suburb: "",
          suburbWarn: false,
          mobile: "",
          mobileWarn: false,
          email: "",
          postcode: "",
          postcodeWarn: false,
          emailwarn: false
        }
      ];
      that.legal = {
        companyName: "",
        companyWarn: false,
        person: "",
        personWarn: false,
        address: "",
        addressWarn: false,
        suburb: "",
        suburbWarn: false,
        state: "",
        stateWarn: false,
        postcode: "",
        postcodeWarn: false,
        openState: false,
        email: "",
        emailWarn: false,
        mobile: "",
        mobileWarn: false,
        phone: "",
        phoneWarn: false
      };
      that.cardInfo = {
        cardName: "",
        cardNameWarn: false,
        cardNumber: "",
        cardNumberWarn: false,
        cardCvv: "",
        cardCvvWarn: false,
        cardMonth: "",
        cardYear: "",
        cardDate: false
      };
      that.agreementDate = "";
      that.agreementDateWarn = false;
      that.agreementName = "";
      that.agreementNameWarn = false;
      that.purchasingEntity = "";
      that.promisePurchaser = null;
      that.promiseLegal = null;
      that.promiseOther = null;
    }
    that.getPropertyDtl({
      params: { id: that.$route.params.id, roomId: that.$route.params.roomId },
      callback: that.callback
    });
    that.getUserDtl({ callback: that.userCallback });
  },
  computed: {
    ...mapState({
      time: state => state.login.time
    })
  },
  methods: {
    toSign() {
      this.haveSign = true;
    },
    sign() {
      var that = this;
      if (
        that.allPurchaser[0].email.replace(/\s+/g, "") == "" ||
        that.allPurchaser[0].firstName.replace(/\s+/g, "") == "" ||
        that.allPurchaser[0].surName.replace(/\s+/g, "") == "" ||
        that.allPurchaser[0].emailwarn
      ) {
        if (
          that.allPurchaser[0].email.replace(/\s+/g, "") == "" ||
          that.allPurchaser[0].emailwarn
        ) {
          that.allPurchaser[0].emailwarn = true;
          document.getElementById("emil").scrollIntoView();
        }
        if (that.allPurchaser[0].firstName.replace(/\s+/g, "") == "") {
          that.signFirName = true;
          document.getElementById("first").scrollIntoView();
        }
        if (that.allPurchaser[0].surName.replace(/\s+/g, "") == "") {
          that.signSurName = true;
          document.getElementById("sur").scrollIntoView();
        }
        return;
      }
      /*this.$box.loadings()
      this.getSignUrl({params: {
          propertyId: this.$route.params.id,
          roomId: this.$route.params.roomId,
          tempName: this.item.apt + ' / ' + this.item.address + ' ' + this.item.suburb + ' ' + this.item.state + ' ' + this.item.postcode,
          email: this.allPurchaser[0].email,
          name: this.allPurchaser[0].firstName + ' ' + this.allPurchaser[0].surName,
          webType: 'mobile'
      }, callback: this.signcallback})*/
      // that.link = 'http://192.168.50.56:8086/#/?event=signing_complete&propertyId=18N87556&roomId=room_jc8L0e8ksfm/'
      that.showsign = true;
      // 把已经填好的信息存
      localStorage.setItem("cardType", that.cardType);
      localStorage.setItem("signwarn", that.signwarn);
      localStorage.setItem("num", that.num);
      localStorage.setItem("disable", that.disable);
      localStorage.setItem("signSurName", that.signSurName);
      localStorage.setItem("signFirName", that.signFirName);
      localStorage.setItem("allPurchaser", JSON.stringify(that.allPurchaser));
      localStorage.setItem("legal", JSON.stringify(that.legal));
      localStorage.setItem("cardInfo", JSON.stringify(that.cardInfo));
      localStorage.setItem("agreementDate", that.agreementDate);
      localStorage.setItem("agreementDateWarn", that.agreementDateWarn);
      localStorage.setItem("agreementName", that.agreementName);
      localStorage.setItem("agreementNameWarn", that.agreementNameWarn);
      localStorage.setItem("purchasingEntity", that.purchasingEntity);
      localStorage.setItem("promisePurchaser", that.promisePurchaser);
      localStorage.setItem("promiseLegal", that.promiseLegal);
      localStorage.setItem("promiseOther", that.promiseOther);
      localStorage.setItem("checked", that.checked);
    },
    closesign() {
      this.showsign = false;
    },
    signcallback(res) {
      var that = this;
      that.$box.loadings(2);
      if (res.data.code == 0) {
        that.link = res.data.data;
        that.showsign = true;
        //window.open(res.data.data, '_blank')
        /*var a = document.createElement("a");
        a.setAttribute("href", res.data.data);
        a.setAttribute("target", "_blank");
        a.click();*/
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    // 判断是否输入完整，输入框失焦的时候判断
    isFilled(validate) {
      var that = this;
      that.promisePurchaser = null;
      that.promiseLegal = null;
      that.promiseOther = null;
      // 判断客户信息是否已经填写完整：第一个必填
      that.promisePurchaser = new Promise(resolve => {
        let num = 0;
        that.allPurchaser.find((v, i) => {
          if (i == 0) {
            if (
              v.title.replace(/\s+/g, "").length > 0 &&
              v.state.replace(/\s+/g, "").length > 0 &&
              v.firstName.replace(/\s+/g, "").length > 0 &&
              v.suburb.replace(/\s+/g, "").length > 0 &&
              v.mobile.replace(/\s+/g, "").length > 0 &&
              v.email.replace(/\s+/g, "").length > 0 &&
              v.postcode.replace(/\s+/g, "").length > 0
            ) {
              num++;
              if (num == 1) {
                resolve(true);
              }
            } else {
              resolve(false);
            }
          }
        });
      });
      // 判断法人信息是否已经填写完整
      that.promiseLegal = new Promise(resolve => {
        if (
          that.legal.companyName.replace(/\s+/g, "").length > 0 &&
          that.legal.person.replace(/\s+/g, "").length > 0 &&
          that.legal.address.replace(/\s+/g, "").length > 0 &&
          that.legal.suburb.replace(/\s+/g, "").length > 0 &&
          that.legal.postcode.replace(/\s+/g, "").length > 0 &&
          that.legal.state.replace(/\s+/g, "").length > 0 &&
          that.legal.mobile.replace(/\s+/g, "").length >
            0 /* &&
                that.legal.phone.replace(/\s+/g,"").length > 0*/
        ) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
      // 判断其他信息卡号等是否填写完整
      that.promiseOther = new Promise(resolve => {
        if (
          that.$box
            .formatReserveDate(that.agreementDate)
            .replace(/\s+/g, "") !== "" &&
          that.agreementName.replace(/\s+/g, "").length > 0 &&
          that.cardInfo.cardName.replace(/\s+/g, "").length > 0 &&
          that.cardInfo.cardNumber.replace(/\s+/g, "").length > 0 &&
          that.cardInfo.cardCvv.replace(/\s+/g, "").length > 0 &&
          that.cardInfo.cardMonth.replace(/\s+/g, "").length > 0 &&
          that.cardInfo.cardYear.replace(/\s+/g, "").length > 0
        ) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
      Promise.all([
        that.promisePurchaser,
        that.promiseLegal,
        that.promiseOther
      ]).then(result => {
        // 法人必填
        if (result[0] && result[1] && result[2] && !that.checked) {
          that.disable = false;
        }
        // 法人选填
        else if (result[0] && result[2] && that.checked) {
          that.disable = false;
        } else {
          that.disable = true;
        }
      });
      if (validate == "validate") {
        that.cardType = "";
        that.getType({
          params: { nums: that.cardInfo.cardNumber },
          callback: that.typeCallback
        });
      }
    },
    typeCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        that.cardType = res.data.data;
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    ...mapActions("property", [
      "getPropertyDtl",
      "submitInfo",
      "getType",
      "getSignUrl"
    ]),
    ...mapActions("account", ["getUserDtl"]),
    ...mapMutations("login", ["addtime"]),
    // 获取房产详情的回调
    callback(res) {
      var that = this;
      if (res.data.code == 0) {
        var datum = res.data.data;
        if (datum.imageUrl.indexOf(",") !== -1) {
          datum.imgLst = datum.imageUrl.split(",");
        } else {
          datum.imgLst = [datum.imageUrl];
        }
        datum.rental = that.$box.formatSplit(datum.rental, true);
        datum.maxRental =
          datum.maxRental !== 0
            ? that.$box.formatSplit(datum.maxRental, true)
            : null;
        datum.commision = that.$box.formatSplit(
          parseInt(datum.commision),
          true
        );
        datum.price = that.$box.formatSplit(datum.price, true);
        datum.maxPrice = that.$box.formatSplit(datum.maxPrice, true);
        datum.landPrice =
          datum.landPrice !== ""
            ? that.$box.formatSplit(datum.landPrice, true)
            : "";
        datum.buildPrice =
          datum.buildPrice !== ""
            ? that.$box.formatSplit(datum.buildPrice, true)
            : "";

        that.item = datum;
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    // 获取用户详情的回调
    userCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        that.user = res.data.data;
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 8902 ||
        res.data.code == 8901
      ) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    // 输入过程去掉红色框
    validateWarn(e, type, id) {
      var that = this;
      if (type == "code") {
        that.allPurchaser.find((v, i) => {
          if (v.purchaserId == id) {
            e.target.value = e.target.value.slice(0, 4);
            this.$forceUpdate();
          }
        });
      }
      if (type == "mobile") {
        that.allPurchaser.find((v, i) => {
          if (v.purchaserId == id) {
            e.target.value = e.target.value.slice(0, 15);
            this.$forceUpdate();
          }
        });
      }
      if (that.allPurchaser[0].firstName.replace(/\s+/g, "") !== "") {
        that.allPurchaser[0].fristWarn = false;
      }
      if (that.allPurchaser[0].surName.replace(/\s+/g, "") !== "") {
        that.allPurchaser[0].surWarn = false;
      }
      if (that.allPurchaser[0].suburb.replace(/\s+/g, "") !== "") {
        that.allPurchaser[0].suburbWarn = false;
      }
      var reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      if (reg.test(that.allPurchaser[0].email)) {
        that.allPurchaser[0].emailwarn = false;
      }
      if (that.allPurchaser[0].postcode.replace(/\s+/g, "") !== "") {
        that.allPurchaser[0].postcodeWarn = false;
      }
      if (that.allPurchaser[0].address.replace(/\s+/g, "") !== "") {
        that.allPurchaser[0].addressWarn = false;
      }
      if (that.allPurchaser[0].mobile.replace(/\s+/g, "") !== "") {
        that.allPurchaser[0].mobileWarn = false;
      }
      if (that.agreementName.replace(/\s+/g, "") !== "") {
        that.agreementNameWarn = false;
      }
      // 找到对应的客户进行验证
      that.allPurchaser.find(v => {
        if (v.purchaserId == id) {
          if (type == "code") v.postcode = e.target.value.replace(/[^\d]/g, "");
          else v.mobile = e.target.value.replace(/[^\d]/g, "");
          that.$forceUpdate();
        }
      });
    },
    // 选中后去掉红色框
    validateSelect() {
      var that = this;
      that.isFilled();
      /* if (that.allPurchaser[0].title.replace(/\s+/g,"") !== '') {
          that.allPurchaser[0].titleWarn = false
      }
      if (that.allPurchaser[0].state.replace(/\s+/g,"") !== '') {
          that.allPurchaser[0].stateWarn = false
      } */
      if (that.legal.state.replace(/\s+/g, "") !== "") {
        that.legal.stateWarn = false;
      }
    },
    posChange(id, val) {
      var that = this;
      that.isFilled();
      that.allPurchaser.forEach(v => {
        if (v.purchaserId == id) {
          v.open = false;
          v.title = val;
          if (that.allPurchaser[0].title.replace(/\s+/g, "") !== "") {
            that.allPurchaser[0].titleWarn = false;
          }
          if (that.allPurchaser[0].state.replace(/\s+/g, "") !== "") {
            that.allPurchaser[0].stateWarn = false;
          }
        }
      });
    },
    posChange2(id, val) {
      var that = this;
      that.isFilled();
      that.allPurchaser.forEach(v => {
        if (v.purchaserId == id) {
          v.open2 = false;
          v.state = val;
          if (that.allPurchaser[0].state.replace(/\s+/g, "") !== "") {
            that.allPurchaser[0].stateWarn = false;
          }
          if (that.allPurchaser[0].state.replace(/\s+/g, "") !== "") {
            that.allPurchaser[0].stateWarn = false;
          }
        }
      });
    },
    posChange3(val) {
      this.isFilled();
      this.legal.state = val;
      this.legal.openState = false;
      if (this.legal.state.replace(/\s+/g, "") !== "") {
        this.legal.stateWarn = false;
      }
    },
    openSelect(id, type) {
      var that = this;
      that.allPurchaser.forEach(v => {
        if (v.purchaserId == id) {
          if (type == "title") {
            v.open = !v.open;
          } else {
            v.open2 = !v.open2;
          }
        }
      });
    },
    openlegel() {
      this.legal.openState = !this.legal.openState;
    },
    closeSelect() {
      this.allPurchaser.forEach(v => {
        v.open = false;
        v.open2 = false;
      });
      this.legal.openState = false;
    },
    dateChange() {
      var that = this;
      if (that.agreementDate !== "") {
        that.agreementDateWarn = false;
        that.isFilled();
      } else {
        that.agreementDateWarn = true;
      }
    },
    // 提交信息
    submit() {
      var that = this;
      if (that.allPurchaser[0].title.replace(/\s+/g, "") == "") {
        that.allPurchaser[0].titleWarn = true;
      }
      if (that.allPurchaser[0].state.replace(/\s+/g, "") == "") {
        that.allPurchaser[0].stateWarn = true;
      }
      if (that.allPurchaser[0].firstName.replace(/\s+/g, "") == "") {
        that.allPurchaser[0].fristWarn = true;
      }
      if (that.allPurchaser[0].surName.replace(/\s+/g, "") == "") {
        that.allPurchaser[0].surWarn = true;
      }
      if (that.allPurchaser[0].suburb.replace(/\s+/g, "") == "") {
        that.allPurchaser[0].suburbWarn = true;
      }
      if (that.allPurchaser[0].email.replace(/\s+/g, "") == "") {
        that.allPurchaser[0].emailwarn = true;
      }
      if (that.allPurchaser[0].postcode.replace(/\s+/g, "") == "") {
        that.allPurchaser[0].postcodeWarn = true;
      }
      if (that.allPurchaser[0].address.replace(/\s+/g, "") == "") {
        that.allPurchaser[0].addressWarn = true;
      }
      if (that.allPurchaser[0].mobile.replace(/\s+/g, "") == "") {
        that.allPurchaser[0].mobileWarn = true;
      }

      // 不打勾必填的情况
      if (!that.checked) {
        if (that.legal.companyName.replace(/\s+/g, "") == "") {
          that.legal.companyWarn = true;
        }
        if (that.legal.person.replace(/\s+/g, "") == "") {
          that.legal.personWarn = true;
        }
        if (that.legal.address.replace(/\s+/g, "") == "") {
          that.legal.addressWarn = true;
        }
        if (that.legal.suburb.replace(/\s+/g, "") == "") {
          that.legal.suburbWarn = true;
        }
        if (that.legal.state.replace(/\s+/g, "") == "") {
          that.legal.stateWarn = true;
        }
        if (that.legal.postcode.replace(/\s+/g, "") == "") {
          that.legal.postcodeWarn = true;
        }
        if (that.legal.mobile.replace(/\s+/g, "") == "") {
          that.legal.mobileWarn = true;
        }
        /* if (that.legal.phone.replace(/\s+/g,'') == '') {
            that.legal.phoneWarn = true
        } */
        if (that.legal.email.replace(/\s+/g, "") == "") {
          that.legal.emailWarn = true;
        }
      }

      if (that.agreementName.replace(/\s+/g, "") == "") {
        that.agreementNameWarn = true;
      }
      if (
        that.$box.formatReserveDate(that.agreementDate).replace(/\s+/g, "") ==
        ""
      ) {
        that.agreementDateWarn = true;
      }
      if (that.cardInfo.cardName.replace(/\s+/g, "") == "") {
        that.cardInfo.cardNameWarn = true;
      }
      if (that.cardInfo.cardNumber.replace(/\s+/g, "") == "") {
        that.cardInfo.cardNumberWarn = true;
      }
      if (that.cardInfo.cardCvv.replace(/\s+/g, "") == "") {
        that.cardInfo.cardCvvWarn = true;
      }
      if (
        that.cardInfo.cardMonth.replace(/\s+/g, "") == "" ||
        that.cardInfo.cardYear.replace(/\s+/g, "") == ""
      ) {
        that.cardInfo.cardDate = true;
      }
      if (that.disable) {
        return false;
      }
      // 先把客户列表的信息筛选成后台要接收的格式
      var ordersPurchaserVOList = [];
      this.allPurchaser.forEach(v => {
        ordersPurchaserVOList.push({
          address: v.address,
          email: v.email,
          firstName: v.firstName,
          gender: v.title,
          mobile: v.mobile,
          state: v.state,
          suburb: v.suburb,
          surName: v.surName,
          postCode: v.postcode
        });
      });
      // 再把购买人的信息整合成后端接收的格式
      var ordersPurchaserLegalVO = {
        address: that.legal.address,
        companyName: that.legal.companyName,
        contactPerson: that.legal.person,
        email: that.legal.email,
        mobile: that.legal.mobile,
        phone: that.legal.phone,
        state: that.legal.state,
        suburb: that.legal.suburb,
        postCode: that.legal.postcode
      };
      // 再把卡的信息整合成后端接收的格式
      if (that.cardInfo.cardMonth.length == 1) {
        that.cardInfo.cardMonth = "0" + that.cardInfo.cardMonth;
      }
      var ordersCardbagVO = {
        cardCvv: that.cardInfo.cardCvv,
        cardName: that.cardInfo.cardName,
        cardNumber: that.cardInfo.cardNumber,
        expMonth: that.cardInfo.cardMonth,
        expYear: that.cardInfo.cardYear
      };
      // 全部信息
      var OrdersBookVO = {
        agreementDate: that.$box.formatReserveDate(that.agreementDate),
        agreementName: that.agreementName,
        ordersCardbagVO: ordersCardbagVO,
        ordersPurchaserLegalVO: ordersPurchaserLegalVO,
        ordersPurchaserVOList: ordersPurchaserVOList,
        purchasingEntity:
          that.purchasingEntity.replace(/\s+/g, "") == ""
            ? ""
            : that.purchasingEntity,
        propertyId: that.$route.params.id,
        roomId:
          that.$route.params.roomId == "room" ? "" : that.$route.params.roomId
      };
      // 开始提交
      that.$box.loadings();
      that.submitInfo({ params: OrdersBookVO, callback: that.submitCallback });
    },
    submitCallback(res) {
      var that = this;
      that.$box.loadings(2);
      if (res.data.code == 0) {
        //8848
        that.$router.push({
          name: "propertyComplete",
          params: {
            id: that.$route.params.id,
            roomId: that.$route.params.roomId
          }
        });
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 70020) {
        that
          .$confirm("Property has expired", "error", {
            distinguishCancelAndCLOse: true,
            confirmBUttonText: "Back to Home"
          })
          .then(() => {
            that.$router.replace("/");
          })
          .catch(action => {
            console.log(action);
          });
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    /****************************************** 卡的信息 start ******************************************/
    cardHandleInput(e, type) {
      var that = this;
      if (type == "month") {
        that.cardInfo.cardMonth = e.target.value.replace(/[^\d]/g, "");
        if (that.cardInfo.cardMonth.slice(0, 1) == "1") {
          if (
            that.cardInfo.cardMonth.slice(1, 2) !== "0" &&
            that.cardInfo.cardMonth.slice(1, 2) !== "1" &&
            that.cardInfo.cardMonth.slice(1, 2) !== "2"
          ) {
            that.cardInfo.cardMonth = that.cardInfo.cardMonth.slice(0, 1);
            that.$forceUpdate();
          }
        } else if (that.cardInfo.cardMonth.slice(0, 1) == "0") {
          that.$forceUpdate();
        } else if (that.cardInfo.cardMonth.slice(0, 1) == "") {
          that.$forceUpdate();
        } else {
          that.cardInfo.cardMonth = "0" + that.cardInfo.cardMonth.slice(0, 1);
          that.$forceUpdate();
        }

        if (that.cardInfo.cardMonth.length == 2) {
          that.$refs.year.focus();
        }

        e.target.value = e.target.value.slice(0, 2);
      } else if (type == "year") {
        that.cardInfo.cardYear = e.target.value.replace(/[^\d]/g, "");
        if (that.cardInfo.cardYear == "") {
          that.$refs.month.focus();
        }
        that.cardInfo.cardYear = that.cardInfo.cardYear.slice(0, 2);
      } else if (type == "number") {
        this.cardInfo.cardNumber = e.target.value.replace(/[^\d]/g, "");
        this.cardInfo.cardNumber = this.cardInfo.cardNumber.slice(0, 16);
      } else if (type == "cvv") {
        this.cardInfo.cardCvv = e.target.value.replace(/[^\d]/g, "");
        this.cardInfo.cardCvv = this.cardInfo.cardCvv.slice(0, 3);
      }

      if (that.cardInfo.cardName.replace(/\s+/g, "") !== "") {
        that.cardInfo.cardNameWarn = false;
      }
      if (that.cardInfo.cardNumber.replace(/\s+/g, "") !== "") {
        that.cardInfo.cardNumberWarn = false;
      }
      if (that.cardInfo.cardCvv.replace(/\s+/g, "") !== "") {
        that.cardInfo.cardCvvWarn = false;
      }
      if (
        that.cardInfo.cardMonth.replace(/\s+/g, "") !== "" &&
        that.cardInfo.cardYear.replace(/\s+/g, "") !== ""
      ) {
        that.cardInfo.cardDate = false;
      }
    },
    /****************************************** 卡的信息 end ******************************************/
    /****************************************** 客户列表 start ******************************************/
    // 校验邮箱
    validateEmail(e, id) {
      var that = this;
      // 找到对应的客户进行验证
      that.allPurchaser.find((v, i) => {
        if (v.purchaserId == id) {
          if (v.email == "") {
            v.emailwarn = false;
            return;
          }
          var reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
          if (reg.test(v.email)) {
            v.emailwarn = false;
          } else {
            v.emailwarn = true;
            if (i == 0) {
              that.disable = true;
            }
          }
          that.$forceUpdate();
        }
      });
    },
    // 清除邮箱
    clean(type, id) {
      this.allPurchaser.find(v => {
        if (v.purchaserId == id) {
          if (type == "email") v.emailwarn = false;
          v.email = "";
          this.$forceUpdate();
        }
      });
    },
    // 去编辑个人信息
    edit() {
      var that = this;
      that.$router.push({
        name: "edit",
        params: { id: that.$route.params.id, roomId: that.$route.params.roomId }
      });
    },
    // 下拉框的箭头翻转
    visible(e, id) {
      // 找到对应的客户，让箭头转一下
      this.allPurchaser.find(v => {
        if (v.purchaserId == id) {
          v.open = e;
          this.$forceUpdate();
        }
      });
    },
    // 下拉框的箭头翻转
    visibleState(e, id) {
      // 找到对应的客户，让箭头转一下
      this.allPurchaser.find(v => {
        if (v.purchaserId == id) {
          v.openState = e;
          this.$forceUpdate();
        }
      });
    },
    // 增加一个客户
    add() {
      var that = this;
      if (that.num > 9) {
        return false;
      }
      that.num++;
      that.allPurchaser.push({
        purchaserId: that.num,
        title: "",
        open: false,
        open2: false,
        state: "",
        openState: false,
        firstName: "",
        surName: "",
        address: "",
        suburb: "",
        mobile: "",
        email: "",
        postcode: ""
      });
    },
    /****************************************** 客户列表  end ******************************************/
    /****************************************** 法人 start ******************************************/
    legalVisibleState(e) {
      this.legal.openState = e;
    },
    legalhandleInput(e, type) {
      var that = this;
      if (that.legal.companyName.replace(/\s+/g, "") !== "") {
        that.legal.companyWarn = false;
      }
      if (that.legal.person.replace(/\s+/g, "") !== "") {
        that.legal.personWarn = false;
      }
      if (that.legal.address.replace(/\s+/g, "") !== "") {
        that.legal.addressWarn = false;
      }
      if (that.legal.suburb.replace(/\s+/g, "") !== "") {
        that.legal.suburbWarn = false;
      }
      if (that.legal.postcode.replace(/\s+/g, "") !== "") {
        that.legal.postcodeWarn = false;
      }
      if (that.legal.mobile.replace(/\s+/g, "") !== "") {
        that.legal.mobileWarn = false;
      }
      if (that.legal.email.replace(/\s+/g, "") !== "") {
        that.legal.emailWarn = false;
      }
      /* if (that.legal.phone.replace(/\s+/g,'') !== '') {
          that.legal.phoneWarn = false
      } */
      if (type == "code") {
        this.legal.postcode = e.target.value.replace(/[^\d]/g, "");
        this.legal.postcode = this.legal.postcode.slice(0, 4);
      } else if (type == "mobile") {
        this.legal.mobile = e.target.value.replace(/[^\d]/g, "");
        this.legal.mobile = this.legal.mobile.slice(0, 15);
      } else if (type == "phone") {
        this.legal.phone = e.target.value.replace(/[^\d]/g, "");
        this.legal.phone = this.legal.phone.slice(0, 15);
      }
    },
    legalClean() {
      var that = this;
      that.legal.emailWarn = false;
      that.legal.email = "";
    },
    legalValidateEmail() {
      var that = this;
      if (that.legal.email == "") {
        that.legal.emailWarn = false;
        return;
      }
      var reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      if (reg.test(that.legal.email)) {
        that.legal.emailWarn = false;
      } else {
        that.legal.emailWarn = true;
        // 如果是必填的情况
        if (!that.checked) that.disable = true;
      }
      that.validateWarn();
    },
    name() {
      var that = this;
      if (that.allPurchaser[0].firstName.replace(/\s+/g, "") !== "") {
        that.signFirName = false;
        that.allPurchaser[0].fristWarn = false;
      }
      if (that.allPurchaser[0].surName.replace(/\s+/g, "") !== "") {
        that.signSurName = false;
        that.allPurchaser[0].surWarn = false;
      }
    }
    /****************************************** 法人 end ******************************************/
  },
  components: {
    headNav,
    footNav
  }
};
</script>

<style lang="scss" scoped>
.link {
  display: block;
  width: 2.2rem;
  height: 1rem;
  line-height: 1rem;
  background: #2cca73;
  color: #fff;
  font-size: 0.3rem;
  text-align: center;
}

.innerWrapper {
  width: 100%;
  padding: 1.52rem 0.24rem 0 0.24rem;
  box-sizing: border-box;

  .top {
    font-size: 16px;
    margin-bottom: 1px;
    text-align: right;
    color: #3f3f46;
  }

  h1 {
    font-size: 0.56rem;
    line-height: 0.68rem;
    color: #2a2929;
    margin-bottom: 0.8rem;
    font-family: ProximaNova-Semibold;
  }

  .container {
    width: 100%;
    margin: 0 auto;

    .info {
      width: 100%;
      box-sizing: border-box;
      padding: 0.4rem 0.32rem 0.48rem 0.32rem;
      border-radius: 0.04rem;
      border: 1px solid #e2e0e3;
      margin-bottom: 0.64rem;

      h1 {
        font-size: 0.32rem;
        line-height: 0.38rem;
        text-align: right;
        color: #3f3f46;
      }

      h2 {
        color: #979497;
        font-size: 0.24rem;
        line-height: 0.28rem;
        margin-top: -0.1rem;
        margin-bottom: 0.24rem;
      }

      h3 {
        font-size: 0.52rem;
        line-height: 0.62rem;
        color: #3f3f46;
        margin-bottom: 0.12rem;
      }

      h6 {
        font-size: 0.4rem;
        color: #979497;
        margin: 0 0 0.32rem;
        text-align: left;
        padding: 0;
      }

      .dtl {
        width: 100%;
        position: relative;
        padding: 0.06rem 0;
        margin-bottom: 0.22rem;

        p {
          font-size: 0.28rem;
          color: #979497;
          margin-bottom: 0.1rem;
          display: flex;
          flex-direction: row;

          span:nth-child(1) {
            flex: 0 0 auto;
            width: 3.2rem;
            text-align: right;
            vertical-align: top;
            margin-right: 0.35rem;
          }

          span:nth-child(2) {
            flex: 1;
            color: #3f3f46;
            display: inline-block;
            word-break: break-word;
            text-align: left;
          }
        }

        p:nth-last-child(1) {
          margin: 0;
        }
      }

      .dtl:after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 0.1rem;
        height: 2.3rem;
        //background:rgba(255,239,0,1);
      }
    }

    .dtls {
      width: 100%;
      margin-bottom: 0.8rem;

      h1 {
        font-size: 0.48rem;
        color: #333333;
        line-height: 0.58rem;
        position: relative;
        margin-bottom: 0.9rem;
        font-family: ProximaNova-Regular;
      }

      h1:after {
        content: "";
        width: 1.16rem;
        height: 0.06rem;
        display: block;
        position: absolute;
        left: 0;
        bottom: -0.08rem;
        //background: #FFEF00;
      }

      .newCheck {
        margin-bottom: 0.48rem;
        position: relative;

        .checkleft {
          position: absolute;
          left: 0;
          top: 0;
        }

        .p {
          width: 100%;
          float: right;
          font-size: 0.28rem;
          color: #979797;
          line-height: 0.34rem;
          padding-left: 0.56rem;
          box-sizing: border-box;
          word-break: break-word;
        }
      }

      h2 {
        font-size: 0.32rem;
        color: #333;
        line-height: 0.36rem;
        margin-bottom: 0.36rem;
        font-family: ProximaNova-Semibold;
      }
    }

    .selectItem {
      margin-bottom: 0.36rem;

      .title {
        color: #8f8f8f;
        font-size: 0.28rem;
        line-height: 0.34rem;
        margin-bottom: 0.24rem;
      }

      .select {
        border: 1px solid #e2e0e3;
        border-radius: 0.12rem;
        box-sizing: border-box;
        width: 100%;
        height: 0.92rem;
        position: relative;

        .mol {
          line-height: 0.92rem;
          width: 100%;
          box-sizing: border-box;
          font-size: 0.3rem;
          color: #3f3f46;
          padding-left: 0.2rem;
          height: 0.92rem;
        }

        ul {
          position: absolute;
          width: 80%;
          left: 0;
          top: 1rem;
          z-index: 2;
          border: 1px solid #e4e7ed;
          border-radius: 4px;
          background-color: #fff;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          box-sizing: border-box;

          li {
            font-size: 0.28rem;
            padding: 0 20px;
            position: relative;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #606266;
            height: 0.7rem;
            line-height: 0.7rem;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            cursor: pointer;
          }

          .selected {
            color: #409eff;
            font-weight: 700;
          }
        }
      }

      .red {
        border: 1px solid #ff4e4e;
      }

      .select:before {
        content: "";
        display: block;
        position: absolute;
        right: 0.32rem;
        top: 0.4rem;
        width: 0.26rem;
        height: 0.14rem;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center center;
        background-image: url("../../../assets/arrw.png");
        transition: all 0.5s;
      }

      .open:before {
        transform: rotate(180deg);
      }
    }

    .inputItem {
      margin-bottom: 0.36rem;
      position: relative;

      .title {
        color: #8f8f8f;
        font-size: 0.28rem;
        line-height: 0.34rem;
        margin-bottom: 0.24rem;
      }

      input {
        border: 1px solid #e2e0e3;
        border-radius: 0.12rem;
        box-sizing: border-box;
        width: 100%;
        height: 0.92rem;
        line-height: 0.92rem;
        padding: 0 0.4rem 0 0.36rem;
        font-size: 0.3rem;
        color: #333333;
        outline: none;
        transition: border 0.5s;
      }

      .date {
        border: 1px solid #e2e0e3;
        border-radius: 0.12rem;
        box-sizing: border-box;
        width: 100%;
        height: 0.92rem;
        color: #333333;
        box-sizing: border-box;
      }

      .red {
        border: 1px solid #ff4e4e;
      }

      .close {
        display: block;
        width: 0.8rem;
        height: 0.8rem;
        position: absolute;
        right: 0;
        top: 0.6rem;
        background-repeat: no-repeat;
        background-size: 0.3rem 0.3rem;
        background-position: center center;
        background-image: url("../../../assets/null.png");
        cursor: pointer;
      }

      strong {
        font-weight: normal;
        position: absolute;
        left: 0;
        top: 1.6rem;
        font-size: 0.2rem;
        color: #ff4e4e;
        width: 110%;
      }
    }

    h4 {
      font-size: 0.32rem;
      line-height: 0.38rem;
      text-align: center;
      margin-bottom: 0.52rem;
      color: #2cca73;
      text-decoration: underline;
      cursor: pointer;
      font-family: ProximaNova-Bold;
    }

    h5 {
      font-size: 0.28rem;
      line-height: 0.34rem;
      color: #8f8f8f;
      margin-bottom: 0.8rem;
      text-align: center;
    }

    button {
      display: block;
      margin: 0 auto 0.8rem auto;
      width: 5.18rem;
      height: 0.92rem;
      box-sizing: border-box;
      border-radius: 0.12rem;
      border: 1px solid rgba(44, 202, 115, 1);
      font-size: 0.3rem;
      background: #fff;
      color: #2cca73;
      cursor: pointer;
    }

    .active {
      background: #2cca73;
      color: #fff;
    }

    .disabled {
      background: #a1e4be;
      cursor: not-allowed;
      border: 1px solid #a1e4be;
    }

    p {
      color: #8f8f8f;
      margin-bottom: 0.14rem;
      font-size: 0.27rem;
      line-height: 0.36rem;

      i {
        font-style: normal;
        color: #3f3f46;
        float: right;
        max-width: 4.5rem;
        text-align: right;
      }
    }
  }

  .payWrp {
    width: 100%;
    background: rgba(63, 63, 70, 1);
    border-radius: 0.04rem;
    box-sizing: border-box;
    padding: 0.36rem 0.32rem;
    margin-bottom: 0.8rem;

    h1 {
      font-size: 0.48rem;
      line-height: 0.58rem;
      color: #fff;
      margin-bottom: 0.4rem;
    }

    .inputItem {
      margin-bottom: 0.32rem;

      .title {
        color: #aeabb0;
        font-size: 0.28rem;
        line-height: 0.34rem;
        margin-bottom: 0.16rem;
      }

      input {
        border: 1px solid #aeabb0;
        border-radius: 0.06rem;
        box-sizing: border-box;
        width: 100%;
        height: 0.8rem;
        position: relative;
        line-height: 0.8rem;
        padding-left: 0.32rem;
        font-size: 0.28rem;
        color: #fff;
        outline: none;
        background: transparent;
      }
    }

    .out {
      .bigInputItem {
        width: 100%;
        float: left;
        position: relative;
        margin-bottom: 0.32rem;

        i {
          display: block;
          position: absolute;
          top: 0.8rem;
          right: 0.3rem;
          width: 0.64rem;
          height: 0.4rem;
          background-size: contain;
          background-position: center center;
          background-repeat: no-repeat;
        }

        .visa {
          background-image: url("../../../assets/v.png");
        }

        .master {
          background-image: url("../../../assets/m.png");
        }
      }

      .smlInputItem {
        width: 50%;
        float: left;
        margin-bottom: 0.32rem;
        box-sizing: border-box;
      }

      .smlInputItem:nth-child(1) {
        padding-right: 0.09rem;
      }

      .smlInputItem:nth-child(2) {
        padding-left: 0.09rem;
      }

      .title {
        color: #aeabb0;
        font-size: 15px;
        line-height: 18px;
        margin-bottom: 12px;
      }

      input {
        border: 1px solid #aeabb0;
        border-radius: 0.12rem;
        box-sizing: border-box;
        width: 100%;
        height: 0.8rem;
        position: relative;
        line-height: 0.8rem;
        padding-left: 0.32rem;
        font-size: 0.28rem;
        color: #fff;
        outline: none;
        background: transparent;
      }

      .red {
        border: 1px solid #ff4e4e;
      }
    }

    .input {
      border: 1px solid #aeabb0;
      border-radius: 0.12rem;
      box-sizing: border-box;
      width: 100%;
      height: 0.8rem;
      position: relative;
      line-height: 0.8rem;
      font-size: 0.28rem;
      color: #fff;
      outline: none;
      background: transparent;

      input {
        border: none;
        width: 40%;
        float: left;
      }

      span {
        width: 10%;
        text-align: center;
        float: left;
      }

      .red {
        border: 1px solid #ff4e4e;
      }
    }

    .p1 {
      width: 100%;
      font-size: 0.28rem;
      line-height: 0.42rem;
      margin-bottom: 0.4rem;
      color: #edf2ef;
    }

    .p2 {
      width: 5rem;
      margin: 0 auto;
      background-size: 0.4rem 0.458rem;
      background-position: left top;
      background-repeat: no-repeat;
      background-image: url("../../../assets/s.png");
      line-height: 0.34rem;
      font-size: 0.22rem;
      font-style: italic;
      padding-left: 0.4rem;
      color: #848388;
      text-align: center;
    }
  }

  .more {
    h2 {
      font-size: 0.32rem;
      line-height: 0.5rem;
      color: #333333;
      text-align: center;
      margin-bottom: 0.4rem;
    }

    button {
      display: block;
      margin: 0 auto 0.4 auto;
      width: 5.18rem;
      height: 0.92rem;
      box-sizing: border-box;
      border-radius: 0.12rem;
      font-size: 0.3rem;
      background: rgba(44, 202, 115, 1);
      color: #fff;
      cursor: pointer;
    }

    p {
      font-size: 0.24rem;
      color: #7d7a7d;
      text-align: center;
      line-height: 0.36rem;
      margin-bottom: 0.8rem;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.popWrp {
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 16;

  .out {
    width: 100%;
    box-sizing: border-box;
    padding: 0 0.24rem;
    height: 6rem;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -3rem 0 0 -50%;
  }

  .inn {
    width: 100%;
    height: 6rem;
    background: #fff;
    border-radius: 3px;
    overflow: hidden;
    box-sizing: border-box;
    padding-top: 1.6rem;
    position: relative;

    h1 {
      font-size: 0.48rem;
      line-height: 0.58rem;
      font-family: ProximaNova-Semibold;
      color: #3f3f46;
      margin-bottom: 0.6rem;
      position: relative;
      text-align: center;
    }

    h1:after {
      content: "";
      display: block;
      position: absolute;
      left: 0.6rem;
      bottom: -0.2rem;
      width: 1.16rem;
      height: 0.06rem;
      background: #ffef00;
    }

    h2 {
      font-size: 0.3rem;
      line-height: 0.6rem;
      text-align: center;
      color: #2a2929;
      margin-bottom: 0.5rem;
      box-sizing: border-box;
      padding: 0 0.46rem;
      text-align: center;
    }

    .close {
      text-decoration: none;
      display: block;
      margin: 0 auto;
      width: 2.2rem;
      height: 0.9rem;
      border-radius: 0.12rem;
      line-height: 0.9rem;
      text-align: center;
      font-size: 0.28rem;
      box-sizing: border-box;
      cursor: pointer;
      background: rgba(44, 202, 115, 1);
      border: 1px solid rgba(44, 202, 115, 1);
      color: #fff;
    }
  }

  .inn:after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 10px;
    background: #ffef00;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/details/property/write.vue